<template>
  <!-- Page header -->
  <div>
    <div class="page-header page-header-light">
      <div class="page-header-content header-elements-md-inline">
        <div class="page-title d-flex">
          <h4><span class="font-weight-semibold">Proxy list</span></h4>
          <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a>
        </div>
      </div>
    </div>
    <!-- /page header -->
    <!-- Content area -->
    <div class="content">
      <div class="card">
        <div class="table-responsive" :class="{ 'loading-mask': loading }">
          <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">
            Refresh list
          </button>
          <table class="table table-striped table-xs" style="min-height: 100px">
            <thead>
              <tr>
                <th>No.</th>
                <th><i class="icon icon-info22" />IP</th>
                <th><i class="icon icon-info22" />Account Name</th>
                <th><i class="icon icon-info22" />Country</th>
                <th><i class="icon icon-info22" />Status</th>
                <th><i class="icon icon-info22" />Status message</th>
                <th>Created at</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(r, k) in rows">
                <tr>
                  <td style="width: 10px">{{ k + 1 }}</td>
                  <td>{{ r.ip }}</td>
                  <td>{{ r.account_name }}</td>
                  <td>{{ r.country }}</td>
                  <td>{{ r.status }}</td>
                  <td>{{ r.status_message }}</td>
                  <td>{{ r.created_at | formatDate }}</td>
                  <td>
                    <button class="btn btn-primary" v-if="r.status !== 'active'"
                      @click="changeStatus($event, r.ip, 'active')">
                      Activate
                    </button>
                    <button class="btn btn-danger" v-if="r.status == 'active'"
                      @click="changeStatus($event, r.ip, 'inactive')">
                      Deactivate
                    </button>
                    <button class="btn btn-slate" @click="test($event, r.ip)">
                      Test
                    </button>
                  </td>
                  <!-- <td>
                                    <div class="btn-group">
                                        <button class="btn btn-primary" v-tooltip="'Worker settings'" @click="worker = r"><i class="icon icon-pencil" /></button>
                                        <button v-tooltip="'Resets worker starts'" class="btn btn-danger" @click="reset($event, r)"><i class="icon icon-reset" /></button>
                                        <button class="btn btn-danger" @click="remove($event, r)"><i class="icon icon-trash" /></button>
                                    </div>
                                </td> -->
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import EventBus from "@/event_bus";
let interval;
export default {
  components: {},
  data() {
    return {
      rows: [],
      loading: true,
    };
  },
  methods: {
    load(showloader) {
      this.loading = true;
      this.$api.getReq("proxy/list").then((res) => {
        this.rows = res.body.data;
        this.loading = false;
      });
    },
    changeStatus(_, ip, status) {
      this.loading = true;
      this.$api
        .postReq("proxy/" + ip + "/status", { status })
        .then((res) => {
          this.load();
          this.$notify.addSuccess("Status changed");
        })
        .catch((err) => {
          this.loading = false;
          this.$notify.addError("IP test failed: " + err.body.error);
        });
    },
    test(_, ip) {
      this.loading = true;
      this.$api.postReq("proxy/" + ip + "/test").then((res) => {
        this.load();
        if (res.body.status) {
          this.$notify.addSuccess("IP works");
        } else {
          this.$notify.addError("IP test failed: " + res.body.data);
        }
      });
    },
  },
  destroyed() {
    clearInterval(interval);
  },
  mounted() {
    this.load();
  },
};
</script>
<style>
.avsquare {
  width: 7px;
  height: 100%;
  float: left;
  cursor: pointer;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
}

.avsquare:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.avsquare:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

tbody .btn {
  padding: 3px 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProxyList.vue